
export const Config = {

    path: "/product/fiasgeocoded/",

    metricModuleId: "FiasGeocoded",

    texts: {
        appName: "",
        title: [''],
        subtitle: [],
        textInfos: [],
        footer: {},
        report: {},
        drawing: {}
    },

    layers: [],
    featureInfo: {
        properties: [],
        territoryNameFunc: () => {},
        headerFunc: () => {},
        subHeaderFunc: () => {}
    },
    featureId: () => {}
}


